var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListPageWithCreateButton',{attrs:{"showCreateBtn":false}},[_c('template',{slot:"listDataContent"},[_c('teacherSubjectsTable',{attrs:{"headers_prop":_vm.headers,"list_url_prop":`teacher/subjects/in-syllabus/${_vm.$route.params.user_id}`}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }